import axios, { AxiosResponse } from "axios";
import {
  AreaCodesResult,
  IInclusiveRemaining,
  IPhoneNumbersResult,
} from "@/lib/api/phonenumbers/types";
import { IAxiosHeaders } from "@/lib/api/auth/types";

const apiPhoneNumbers = {
  getAreaCodes: async (
    country_value: string,
  ): Promise<AxiosResponse<AreaCodesResult>> => {
    return await axios({
      method: "GET",
      url: `/svc/area-codes/${country_value}/dashboard-names`,
    });
  },
  getPhoneNumbers: async ({
                            area_code,
                            pattern,
                            limit,
                            page,
                            number_type,
                            country_code,
                            headers,
                          }: {
    area_code?: string;
    pattern?: string;
    limit?: number;
    page?: number;
    number_type?: string;
    country_code?: string;
    headers?: IAxiosHeaders;
  }): Promise<AxiosResponse<IPhoneNumbersResult>> => {
    return await axios({
      method: "GET",
      url: "/api/voice/number-search",
      params: {
        area_code: area_code || 20,
        pattern: pattern || "**",
        limit: limit || 20,
        page: page || 1,
        type: number_type || "standard",
        country_code: country_code || 44,
        include_price: "yes",
      },
      headers,
    });
  },
  hasVoip: async (): Promise<
    AxiosResponse<{
      has_voip_cart: boolean;
      has_voip_cart_users: boolean;
      has_voip_customer: boolean;
      has_voip_trial: boolean;
    }>
  > => {
    return await axios({
      method: "GET",
      url: `/api/has-voip`,
    });
  },
  getInclusiveRemaining: async (options?: {
    headers: IAxiosHeaders;
  }): Promise<AxiosResponse<IInclusiveRemaining>> => {
    return await axios({
      method: "GET",
      url: `/svc/number-search/get-inclusive-remaining`,
      headers: options?.headers,
    });
  },
};

export default apiPhoneNumbers;
